/**
 * @author liqiuqi
 * @date 2022 2022/4/24 13:55
 */
import { Message } from "element-ui";

function basicFunctionInit() {
  // 重写 window.open
  window.open = (url) => {
    const form = document.createElement("a");
    form.href = url;
    form.target = "_blank";
    document.body.appendChild(form);
    form.click();
    form.remove();
  };
}

function basicListenersInit() {
  window.addEventListener("online", () => {
    Message.closeAll();
    console.log("online");
  });
  window.addEventListener("offline", () => {
    Message({
      message: "您的网络已断开，请检查网络连接是否正常",
      type: "error",
      duration: 0,
      showClose: true,
    });
    console.log("offline");
  });
}

const systemInit = {
  basicFunctionInit,
  basicListenersInit,
};

export default systemInit;
